type Layered = { id: string; zIndex: number }

/**
 * New stacking orders that bring `ids` all the way to the front (or back), keeping their order
 * among themselves and everyone else's. The result numbers the layers 1…n from the back.
 */
const moveToEdge = (layers: Layered[], ids: string[], edge: "front" | "back") => {
  const ordered = [...layers].sort((a, b) => a.zIndex - b.zIndex)
  const moving = ordered.filter((layer) => ids.includes(layer.id))
  const others = ordered.filter((layer) => !ids.includes(layer.id))
  const stack = edge === "front" ? [...others, ...moving] : [...moving, ...others]

  return new Map(stack.map((layer, index) => [layer.id, index + 1]))
}

export default moveToEdge
